module.exports = __webpack_public_path__ + "static/img/icon-safe4.b5e0894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe4.png
// module id = ClqC
// module chunks = 21